// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Et5J","largestCol":"styles_largestCol__2iLCY","smallestCol":"styles_smallestCol__2H6nQ"};